import { render, staticRenderFns } from "./car-insurance-companies.html?vue&type=template&id=bdf5bb6c&scoped=true&"
import script from "./car-insurance-companies.js?vue&type=script&lang=js&"
export * from "./car-insurance-companies.js?vue&type=script&lang=js&"
import style0 from "./car-insurance-companies.scss?vue&type=style&index=0&id=bdf5bb6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf5bb6c",
  null
  
)

export default component.exports